// Where sign-in sends someone back to, when a page sent them to /signup to finish something there (the Character.AI
// importer, 16 October 2026: its screenshots wait in the browser while the account is made). Until then sign-in always
// landed on /explore and there was no way back (SignUpComponent).
//
// One-shot (read once, then gone), a path on this site only (never another host, never /signup itself), and only for
// 30 minutes, so a stale one cannot hijack a later, unrelated sign-in. Email-link sign-in arrives in a new tab, which is
// why this is localStorage and not sessionStorage.
import {
  safeGetItem,
  safeRemoveItem,
  safeSetItem,
} from '../helpers/safeStorage.js'

const KEY = 'returnAfterSignIn'
export const RETURN_TTL_MS = 30 * 60 * 1000

/** A path this site serves that is safe to send someone to after sign-in. */
export function isSafeReturn(path) {
  return (
    typeof path === 'string' &&
    /^\/[a-z0-9][a-z0-9\-/]*$/i.test(path) &&
    !path.startsWith('/signup')
  )
}

/** The stored value's path when it is still good at `now`, else null. */
export function returnFrom(raw, now = Date.now()) {
  try {
    const { path, at } = JSON.parse(raw)
    return isSafeReturn(path) && now - at >= 0 && now - at < RETURN_TTL_MS
      ? path
      : null
  } catch {
    return null
  }
}

export function setReturnTo(path) {
  if (isSafeReturn(path)) {
    safeSetItem(KEY, JSON.stringify({ path, at: Date.now() }))
  }
}

/** The path to return to after sign-in, once, or null. */
export function takeReturnTo() {
  const raw = safeGetItem(KEY)
  if (raw === null) return null
  safeRemoveItem(KEY)
  return returnFrom(raw)
}
